<template>
  <div class="d-inline pull-left">
    <b-modal
      id="edit-contact-modal"
      size="sm"
      :title="modalTitle"
      @shown="resetForm"
      @ok="checkForm"
      :ok-title="isSaving ? 'Saving...' : 'Save'"
      :ok-disabled="isSaving"
      scrollable
    >
      <form id="addContact" @submit="checkForm" action="url" method="post">
        <b-container fluid>
          <b-row>
            <b-col cols="6">
              <b-form-group class="required" label="First Name">
                <b-form-input
                  :class="{ 'is-invalid': $v.contact.firstName.$error }"
                  @blur="$v.contact.firstName.$touch()"
                  v-model.trim="contact.firstName"
                ></b-form-input>
                <div class="invalid-feedback">
                  First Name is required
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group class="required" label="Last Name">
                <b-form-input
                  :class="{ 'is-invalid': $v.contact.lastName.$error }"
                  @blur="$v.contact.lastName.$touch()"
                  v-model.trim="contact.lastName"
                ></b-form-input>
                <div class="invalid-feedback">
                  Last Name is required
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Title">
                <b-form-input
                  v-model.trim="contact.title"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Email">
            <b-form-input
              :class="{ 'is-invalid': $v.contact.email1.$error }"
              @blur="$v.contact.email1.$touch()"
              v-model.trim="contact.email1"
            ></b-form-input>
            <div class="invalid-feedback">
              Invalid email format
            </div>
          </b-form-group>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Phone">
                <b-form-input
                  :class="{ 'is-invalid': $v.contact.phone1.$error }"
                  @blur="$v.contact.phone1.$touch()"
                  v-model.trim="contact.phone1"
                ></b-form-input>
                <div class="invalid-feedback">
                  Invalid phone number
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Mobile">
                <b-form-input
                  :class="{ 'is-invalid': $v.contact.phone2.$error }"
                  @blur="$v.contact.phone2.$touch()"
                  v-model.trim="contact.phone2"
                ></b-form-input>
                <div class="invalid-feedback">
                  Invalid phone number
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <required-descriptor />
        </b-container>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import contactService from '@/resources/ContactService';
import { phoneValidator, emailValidator } from '@/shared/validators';

export default {
  props: [
    'companyId',
    'id',
  ],
  data() {
    return {
      contact: {},
      isSaving: false,
    }
  },
  computed: {
    modalTitle() {
      return this.contact && this.contact.id ? 'Edit contact' : 'New contact';
    },
  },
  validations: {
    contact: {
      firstName: { required },
      lastName: { required },
      phone1: { phoneValidator },
      phone2: { phoneValidator },
      email1: { emailValidator },
    },
  },
  methods: {
    async newContact() {
      this.contact = {};
      this.contact.accountId = this.companyId;
      this.$bvModal.show('edit-contact-modal');
      if (this.id) {
        this.contact.id = this.id;
        let result = await contactService.getOne(this.id);
        this.contact = {...this.contact,...result}
      }
    },
    resetForm() {
      this.$v.$reset();
    },
    hide(dispatchReload = false) {
      this.$refs.editCompanyModal.hide();
      if (dispatchReload) {
        this.$emit('change');
      }
    },
    checkForm: async function(e) {
      this.$v.contact.$touch();
      if (this.$v.contact.$invalid) {
        e.preventDefault();
        return;
      }
      try {
        this.isSaving = true;
        if (!this.contact.id) {
          contactService.create(this.contact).then(contact => {
            this.$emit('created', contact.id);
          });
        } else {
          contactService.update(this.contact).then(contact => {
            this.$emit('created', this.contact.id);
          });
        }
        this.isSaving = false;
      } catch (e) {
        this.isSaving = false;
      }
    },
  },
}
</script>
<style lang="css">
#edit-contact-modal .modal-dialog {
  width: 650px;
}
</style>
